import { useState } from 'react';
// @mui
import { alpha } from '@mui/material/styles';
import { Button, useTheme } from '@mui/material';
//
import Iconify from '../../Iconify';

// ----------------------------------------------------------------------

export default function SettingFullscreen() {
  const [fullscreen, setFullscreen] = useState(false);
  const theme = useTheme();

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setFullscreen(true);
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
      setFullscreen(false);
    }
  };

  return (
    <Button
      fullWidth
      size="large"
      variant="outlined"
      color={fullscreen ? 'primary' : 'inherit'}
      endIcon={
        <Iconify
          icon={fullscreen ? 'ic:round-fullscreen-exit' : 'ic:round-fullscreen'}
        />
      }
      onClick={toggleFullScreen}
      sx={{
        border: `solid 1px ${alpha(theme.palette.grey[500], 0.12)}`,
        typography: 'subtitle2',
        fontSize: 14,
        ...(fullscreen && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.selectedOpacity
            ),
        }),
      }}
    >
      {fullscreen ? 'Exit Fullscreen' : 'Fullscreen'}
    </Button>
  );
}
